import { motion } from "framer-motion";
import { Eye, Flame, Star, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FadeUp } from "./Motion";

/* 30 viral reels: views data + category */
const VIDEOS = [
  { src: "/community/views/processed/v19-1400k.jpg", views: "1.4M",  num: 1400000, cat: "留學生活", title: "但這個世界好像跟我無關" },
  { src: "/community/views/processed/v24-1200k.jpg", views: "1.2M",  num: 1200000, cat: "美食旅遊", title: "上飛機前買蛋餅" },
  { src: "/community/views/processed/v17-854k.jpg",  views: "854K",  num: 854000,  cat: "海外旅遊", title: "你心裡也有個印度" },
  { src: "/community/views/processed/v23-739k.jpg",  views: "739K",  num: 739000,  cat: "航空空姐", title: "颱風航班取消真相" },
  { src: "/community/views/processed/v03-719k.jpg",  views: "719K",  num: 719000,  cat: "青少年教育", title: "青少年鍾意講粗口？" },
  { src: "/community/views/processed/v21-520k.jpg",  views: "520K",  num: 520000,  cat: "醫美專業", title: "他們未曾擁有的選擇權" },
  { src: "/community/views/processed/v07-458k.jpg",  views: "458K",  num: 458000,  cat: "寵物知識", title: "你個仔突然摸我隻狗" },
  { src: "/community/views/processed/v27-404k.jpg",  views: "404K",  num: 404000,  cat: "情感故事", title: "阿媽從反對我是 LES" },
  { src: "/community/views/processed/v06-312k.jpg",  views: "312K",  num: 312000,  cat: "親子育兒", title: "3 句話養出內心強大仔女" },
  { src: "/community/views/processed/v22-284k.jpg",  views: "284K",  num: 284000,  cat: "海外旅遊", title: "Iceland 計劃行程" },
  { src: "/community/views/processed/v13-255k.jpg",  views: "255K",  num: 255000,  cat: "鋼琴教學", title: "鋼琴圈最尷尬的真相" },
  { src: "/community/views/processed/v20-244k.jpg",  views: "244K",  num: 244000,  cat: "航空空姐", title: "服務過十萬名乘客" },
  { src: "/community/views/processed/v14-231k.jpg",  views: "231K",  num: 231000,  cat: "金融投資", title: "內幕交易的工具" },
  { src: "/community/views/processed/v16-208k.jpg",  views: "208K",  num: 208000,  cat: "海外旅遊", title: "母親來到印度第一天" },
  { src: "/community/views/processed/v05-201k.jpg",  views: "201K",  num: 201000,  cat: "親子育兒", title: "青春期不想去拜年" },
  { src: "/community/views/processed/v04-136k.jpg",  views: "136K",  num: 136000,  cat: "親子育兒", title: "子女不懂感恩父母" },
  { src: "/community/views/processed/v10-135k.jpg",  views: "135K",  num: 135000,  cat: "美容護膚", title: "不要亂買補水面膜" },
  { src: "/community/views/processed/v15-132k.jpg",  views: "132K",  num: 132000,  cat: "金融投資", title: "內幕交易的指標" },
  { src: "/community/views/processed/v25-126k.jpg",  views: "126K",  num: 126000,  cat: "美髮造型", title: "夏天女生最怕的事" },
  { src: "/community/views/processed/v02-124k.jpg",  views: "124K",  num: 124000,  cat: "親子育兒", title: "小朋友不是脾氣差" },
  { src: "/community/views/processed/v18-117k.jpg",  views: "117K",  num: 117000,  cat: "內容創作", title: "爆紅影片的開頭" },
  { src: "/community/views/processed/v01-107k.jpg",  views: "107K",  num: 107000,  cat: "親子育兒", title: "五句話幫小朋友冷靜" },
  { src: "/community/views/processed/v09-103k.jpg",  views: "103K",  num: 103000,  cat: "寵物知識", title: "老年犬問題拆解" },
  { src: "/community/views/processed/v26-102k.jpg",  views: "102K",  num: 102000,  cat: "美髮造型", title: "千萬不要拿照片給髮型師看" },
  { src: "/community/views/processed/v12-109k.jpg",  views: "109K",  num: 109000,  cat: "鋼琴教學", title: "女生面前帥一次" },
  { src: "/community/views/processed/v08-95k.jpg",   views: "95K",   num: 95000,   cat: "寵物知識", title: "餵狗吃了十年餅乾" },
  { src: "/community/views/processed/v11-70k.jpg",   views: "70K",   num: 70000,   cat: "求職教練", title: "畢業生搵工率 85%" },
];

function ViewsBadge({ num }) {
  if (num >= 1000000) {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[rgba(233,196,129,0.15)] border border-[rgba(233,196,129,0.45)] text-[#F3D894] text-[9.5px] sm:text-[10px] font-bold uppercase tracking-[0.14em]">
        <Star className="w-2.5 h-2.5" /> VIRAL
      </span>
    );
  }
  if (num >= 300000) {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[rgba(212,180,106,0.12)] border border-[rgba(212,180,106,0.35)] text-[hsl(var(--lime))] text-[9.5px] sm:text-[10px] font-bold uppercase tracking-[0.14em]">
        <Flame className="w-2.5 h-2.5" /> HOT
      </span>
    );
  }
  return null;
}

function VideoCard({ v }) {
  return (
    <div className="group relative flex-shrink-0 w-[170px] sm:w-[200px]" data-testid={`video-card-${v.views.toLowerCase()}`}>
      <div className="relative aspect-[9/16] rounded-2xl overflow-hidden border border-[rgba(212,180,106,0.18)] bg-[#111] shadow-[0_18px_40px_rgba(0,0,0,0.45)] transition-all duration-300 group-hover:border-[rgba(212,180,106,0.5)] group-hover:shadow-[0_22px_55px_rgba(212,180,106,0.22),0_0_0_1px_rgba(212,180,106,0.25)] group-hover:-translate-y-1">
        <img src={v.src} alt={v.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" loading="lazy" />
        <div className="absolute inset-x-0 top-0 h-14 bg-gradient-to-b from-black/60 to-transparent pointer-events-none" />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/85 via-black/45 to-transparent pointer-events-none" />
        <div className="absolute top-2.5 left-2.5 z-10">
          <ViewsBadge num={v.num} />
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-90 transition-opacity duration-300 pointer-events-none">
          <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[hsl(var(--lime))] flex items-center justify-center shadow-[0_8px_30px_rgba(212,180,106,0.6)]">
            <Play className="w-5 h-5 sm:w-6 sm:h-6 text-[#0a0907] fill-[#0a0907] ml-0.5" />
          </div>
        </div>
        <div className="absolute bottom-2.5 left-2.5 right-2.5 z-10">
          <div className="flex items-center gap-1.5">
            <Eye className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white/90" />
            <span className="font-num text-[18px] sm:text-[22px] font-bold text-white leading-none tracking-tight drop-shadow-md">
              {v.views}
            </span>
          </div>
        </div>
      </div>
      <div className="mt-3 px-0.5">
        <div className="text-[9.5px] sm:text-[10px] uppercase tracking-[0.2em] text-[hsl(var(--lime))] font-bold mb-1">
          {v.cat}
        </div>
        <p className="font-serif-tc text-[12px] sm:text-[13px] text-[hsl(var(--foreground))]/90 leading-snug line-clamp-2">
          「{v.title}」
        </p>
      </div>
    </div>
  );
}

/* Marquee row — infinite auto-scroll */
const MarqueeRow = ({ items, reverse = false, speed = 120 }) => {
  const doubled = [...items, ...items];
  return (
    <div className="relative overflow-hidden">
      <div className="absolute inset-y-0 left-0 w-12 sm:w-20 z-10 pointer-events-none"
           style={{ background: "linear-gradient(to right, rgba(10,9,7,1), rgba(10,9,7,0))" }} />
      <div className="absolute inset-y-0 right-0 w-12 sm:w-20 z-10 pointer-events-none"
           style={{ background: "linear-gradient(to left, rgba(10,9,7,1), rgba(10,9,7,0))" }} />
      <motion.div
        className="flex gap-4 sm:gap-6"
        initial={{ x: reverse ? "-50%" : 0 }}
        animate={{ x: reverse ? "0%" : "-50%" }}
        transition={{ duration: speed, ease: "linear", repeat: Infinity }}
        style={{ width: "max-content" }}
      >
        {doubled.map((v, i) => (
          <VideoCard key={`${v.src}-${i}`} v={v} />
        ))}
      </motion.div>
    </div>
  );
};

export const CommunityMembers = ({ onCtaClick }) => {
  const totalViews = VIDEOS.reduce((s, v) => s + v.num, 0);
  const viralCount = VIDEOS.filter((v) => v.num >= 300000).length;
  const totalViewsM = (totalViews / 1000000).toFixed(1);

  // Split into 2 rows (15 each), scrolling opposite directions
  const half = Math.ceil(VIDEOS.length / 2);
  const row1 = VIDEOS.slice(0, half);
  const row2 = VIDEOS.slice(half);

  return (
    <section id="community-members" className="relative py-16 sm:py-24 bg-ink overflow-hidden">
      <div className="absolute inset-0 pointer-events-none"
           style={{ background: "radial-gradient(900px circle at 50% 15%, rgba(212,180,106,0.08), transparent 60%)" }} />

      <div className="relative">
        {/* Header (constrained) */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <FadeUp>
            <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-10">
              <div className="eyebrow justify-center mb-4"><span className="dot" /> MEMBER PORTFOLIOS</div>
              <h2 className="font-serif-tc text-[28px] sm:text-5xl lg:text-6xl font-bold leading-[1.15] tracking-tight">
                社群會員<span className="lime-keyword">案例</span>
              </h2>
              <p className="mt-4 text-[14px] sm:text-[16px] text-[hsl(var(--muted-foreground))] leading-relaxed px-2">
                每條都是同一套方法・不同主題、不同性格、不同階段。
              </p>
            </div>
          </FadeUp>

          <FadeUp delay={0.05}>
            <div className="flex flex-wrap items-center justify-center gap-x-8 sm:gap-x-12 gap-y-3 mb-10 sm:mb-12 text-center">
              <div>
                <div className="stat-num text-[22px] sm:text-[28px] lime-keyword">2000萬+</div>
                <div className="text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-[hsl(var(--muted-foreground))] mt-1">總觀看數</div>
              </div>
              <div className="w-px h-8 bg-[rgba(212,180,106,0.25)]" />
              <div>
                <div className="stat-num text-[22px] sm:text-[28px] lime-keyword">{VIDEOS.length}</div>
                <div className="text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-[hsl(var(--muted-foreground))] mt-1">精選片段</div>
              </div>
              <div className="w-px h-8 bg-[rgba(212,180,106,0.25)]" />
              <div>
                <div className="stat-num text-[22px] sm:text-[28px] lime-keyword">{viralCount}</div>
                <div className="text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-[hsl(var(--muted-foreground))] mt-1">300K+ 爆款</div>
              </div>
              <div className="w-px h-8 bg-[rgba(212,180,106,0.25)]" />
              <div>
                <div className="stat-num text-[22px] sm:text-[28px] lime-keyword">10</div>
                <div className="text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-[hsl(var(--muted-foreground))] mt-1">垂直領域</div>
              </div>
            </div>
          </FadeUp>
        </div>

        {/* Full-width marquee rows */}
        <div className="space-y-5 sm:space-y-7 pb-2">
          <MarqueeRow items={row1} speed={90} />
          <MarqueeRow items={row2} speed={120} reverse />
        </div>

        {/* CTA */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <FadeUp delay={0.1}>
            <div className="mt-12 sm:mt-16 text-center max-w-2xl mx-auto">
              <p className="font-serif-tc text-[15px] sm:text-lg text-[hsl(var(--foreground))]/90 leading-relaxed mb-5 sm:mb-6">
                <span className="lime-keyword">N 個行業，創造過千萬客戶流量</span><br className="hidden sm:inline" />
                分享會現場拆解：他們如何擊中人心、每月自動漲粉。
              </p>
              <Button
                onClick={onCtaClick}
                className="btn-lime btn-lime-pulse h-12 sm:h-13 px-7 sm:px-8 text-[15px] sm:text-base"
                data-testid="members-cta"
              >
                我也要做出爆款
              </Button>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
